"use strict";
const turnstileSelector = '.js-turnstile';
window.up.compiler('body.test', () => {
    if (!window.turnstile) {
        const callbacks = new Map();
        const promptToken = () => { var _a; return (_a = window.prompt('Enter test turnstile token')) !== null && _a !== void 0 ? _a : 'abcd'; };
        const runChallenge = (handle) => {
            const callback = callbacks.get(handle);
            callback === null || callback === void 0 ? void 0 : callback(promptToken());
        };
        let widgetCount = 0;
        window.turnstile = {
            render: (container, params) => {
                const widgetId = 'test-turnstile-widget-' + widgetCount++;
                callbacks.set(container, params.callback);
                callbacks.set(widgetId, params.callback);
                if (params.execution !== 'execute') {
                    params.callback(promptToken());
                }
                return widgetId;
            },
            execute: runChallenge,
            reset: runChallenge,
            remove: handle => {
                callbacks.delete(handle);
            }
        };
    }
});
const insertTokenToInput = (responseInputClass, token) => {
    const inputs = document.querySelectorAll('.' + responseInputClass);
    inputs.forEach(input => (input.value = token));
};
window.up.compiler(turnstileSelector, (element) => {
    const params = element.dataset;
    const responseInputClass = element.dataset.responseInputClass;
    const submitButtonClass = element.dataset.submitButtonClass;
    const submitButton = submitButtonClass && document.querySelector('.' + submitButtonClass);
    const executeTriggerClass = element.dataset.executeTriggerClass;
    const setSubmitButtonDisabled = (disabled) => {
        if (submitButton) {
            submitButton.disabled = disabled;
        }
    };
    if (!window.turnstile || !responseInputClass) {
        return;
    }
    let pendingForm = null;
    window.turnstile.render(element, Object.assign(Object.assign({}, params), { callback: (token) => {
            insertTokenToInput(responseInputClass, token);
            setSubmitButtonDisabled(false);
            if (pendingForm) {
                const form = pendingForm;
                pendingForm = null;
                form.requestSubmit();
            }
        }, 'expired-callback': () => setSubmitButtonDisabled(true), 'error-callback': () => setSubmitButtonDisabled(true), 'timeout-callback': () => setSubmitButtonDisabled(true) }));
    if (params.execution === 'execute' && executeTriggerClass) {
        const trigger = document.querySelector('.' + executeTriggerClass);
        trigger === null || trigger === void 0 ? void 0 : trigger.addEventListener('click', event => {
            event.preventDefault();
            const formId = trigger.getAttribute('form');
            pendingForm = formId ? document.querySelector('#' + formId) : trigger.closest('form');
            window.turnstile.execute(element);
        });
    }
});
